export const LanguageValues = ["en", "el"] as const;
export type LanguageType = typeof LanguageValues[number]
export const EnglishLanguage = LanguageValues[0]
export const GreekLanguage = LanguageValues[1]